/** Fill near-square assets without cropping deliberately tall or wide images. */
export function productCardImageFit(imageUrl?: string): 'object-cover' | 'object-contain' {
  if (!imageUrl) return 'object-contain'

  try {
    const url = new URL(imageUrl)
    // Only Sanity's original asset paths provide trustworthy intrinsic dimensions.
    // Transformed URLs can have a different aspect ratio from the original asset.
    if (
      url.hostname !== 'cdn.sanity.io' ||
      ['w', 'h', 'rect', 'crop', 'fit', 'or'].some((key) => url.searchParams.has(key))
    ) {
      return 'object-contain'
    }
    const dimensions = url.pathname.match(
      /^\/images\/[^/]+\/[^/]+\/[a-f0-9]+-(\d+)x(\d+)\.[a-z0-9]+$/i,
    )
    if (!dimensions) return 'object-contain'

    const width = Number(dimensions[1])
    const height = Number(dimensions[2])
    if (width <= 0 || height <= 0) return 'object-contain'

    return Math.min(width, height) / Math.max(width, height) >= 0.98
      ? 'object-cover'
      : 'object-contain'
  } catch {
    return 'object-contain'
  }
}
